import React, { useState } from 'react';
import { Home, FileText, Camera, Wrench, Users } from 'lucide-react';
import { SiteList } from './pages/SiteList';
import { DailyReport } from './pages/DailyReport';
import { MediaGallery } from './pages/MediaGallery';
import { Toolbox } from './pages/Toolbox';
import { MobileContacts } from './pages/MobileContacts';
import { MobileHeader } from './components/MobileHeader';
type TabType = 'sites' | 'report' | 'media' | 'contacts' | 'tools';
export function MobileApp() {
  const [activeTab, setActiveTab] = useState<TabType>('sites');
  const [selectedSite, setSelectedSite] = useState<string | null>(null);
  const renderContent = () => {
    switch (activeTab) {
      case 'sites':
        return <SiteList onSelectSite={setSelectedSite} data-id="element-15" />;
      case 'report':
        return <DailyReport siteId={selectedSite} data-id="element-16" />;
      case 'media':
        return <MediaGallery data-id="element-17" />;
      case 'contacts':
        return <MobileContacts data-id="element-18" />;
      case 'tools':
        return <Toolbox data-id="element-19" />;
      default:
        return <SiteList onSelectSite={setSelectedSite} data-id="element-20" />;
    }
  };
  return <div className="flex flex-col h-screen bg-gray-50" data-id="element-21">
      <MobileHeader selectedSite={selectedSite} data-id="element-22" />
      <main className="flex-1 overflow-y-auto pb-20" data-id="element-23">{renderContent()}</main>
      {/* Bottom Navigation */}
      <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 safe-area-pb" data-id="element-24">
        <div className="flex justify-around items-center h-16" data-id="element-25">
          <button onClick={() => setActiveTab('sites')} className={`flex flex-col items-center justify-center flex-1 h-full space-y-1 ${activeTab === 'sites' ? 'text-red-600' : 'text-gray-500'}`} data-id="element-26">
            <Home size={22} data-id="element-27" />
            <span className="text-xs font-medium" data-id="element-28">Chantiers</span>
          </button>
          <button onClick={() => setActiveTab('report')} className={`flex flex-col items-center justify-center flex-1 h-full space-y-1 ${activeTab === 'report' ? 'text-red-600' : 'text-gray-500'}`} data-id="element-29">
            <FileText size={22} data-id="element-30" />
            <span className="text-xs font-medium" data-id="element-31">Rapport</span>
          </button>
          <button onClick={() => setActiveTab('media')} className={`flex flex-col items-center justify-center flex-1 h-full space-y-1 ${activeTab === 'media' ? 'text-red-600' : 'text-gray-500'}`} data-id="element-32">
            <Camera size={22} data-id="element-33" />
            <span className="text-xs font-medium" data-id="element-34">Médias</span>
          </button>
          <button onClick={() => setActiveTab('contacts')} className={`flex flex-col items-center justify-center flex-1 h-full space-y-1 ${activeTab === 'contacts' ? 'text-red-600' : 'text-gray-500'}`} data-id="element-35">
            <Users size={22} data-id="element-36" />
            <span className="text-xs font-medium" data-id="element-37">Contacts</span>
          </button>
          <button onClick={() => setActiveTab('tools')} className={`flex flex-col items-center justify-center flex-1 h-full space-y-1 ${activeTab === 'tools' ? 'text-red-600' : 'text-gray-500'}`} data-id="element-38">
            <Wrench size={22} data-id="element-39" />
            <span className="text-xs font-medium" data-id="element-40">Outils</span>
          </button>
        </div>
      </nav>
    </div>;
}